import { Flex } from '@applyboard/crystal-ui';
import { PageHeader } from '../../../components/PageHeader';
import { ApplicationExportTable, ApplicationExportPagination } from '../components';

export function MobileLayout() {
  return (
    <Flex p={4} gap={4} direction="column">
      <PageHeader title="Data Export" />
      <ApplicationExportTable />
      <ApplicationExportPagination />
    </Flex>
  );
}
